const PastVisitsBt: React.FC<{
    isSelected: boolean;
    onClick: () => void;
    count?: number;
}> = ({ onClick, isSelected, count }) => {
    return (
        <div onClick={onClick} className={`menuitem  ${isSelected ? 'selected' : ''}`}>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M18.5312 6.0625L16.9375 4.46875C16.6562 4.1875 16.2812 4.03125 15.875 4H10.5C9.65625 4 9 4.6875 9 5.5V7H6.5C5.65625 7 5 7.6875 5 8.5V18.5C5 19.3438 5.65625 20 6.5 20H13.5C14.3125 20 15 19.3438 15 18.5V17H17.5C18.3125 17 19 16.3438 19 15.5V7.125C18.9688 6.71875 18.8125 6.34375 18.5312 6.0625ZM16 5.03125C16.0625 5.0625 16.1562 5.09375 16.2188 5.15625L17.8438 6.78125C17.9062 6.84375 17.9375 6.9375 17.9688 7H16V5.03125ZM14 18.5C14 18.7812 13.75 19 13.5 19H6.5C6.21875 19 6 18.7812 6 18.5V8.5C6 8.25 6.21875 8 6.5 8H9V15.5C9 16.3438 9.65625 17 10.5 17H14V18.5ZM18 15.5C18 15.7812 17.75 16 17.5 16H10.5C10.2188 16 10 15.7812 10 15.5V5.5C10 5.25 10.2188 5 10.5 5H15V7.25C15 7.6875 15.3125 8 15.75 8H18V15.5ZM14.8125 9.71875C14.8125 9.59375 14.7188 9.5 14.625 9.5H13.375C13.25 9.5 13.1562 9.59375 13.1562 9.71875V11.1875H11.6875C11.5625 11.1875 11.5 11.2812 11.5 11.375V12.625C11.5 12.75 11.5625 12.8438 11.6875 12.8438H13.1562V14.3125C13.1562 14.4375 13.25 14.5 13.375 14.5H14.625C14.7188 14.5 14.8125 14.4375 14.8125 14.3125V12.8438H16.2812C16.4062 12.8438 16.5 12.75 16.5 12.625V11.375C16.5 11.2812 16.4062 11.1875 16.2812 11.1875H14.8125V9.71875Z"></path>
                </svg>
                <p>Past visits</p>
            </div>
            <div className="flex space-x-8">
                {count && count > 0 ? (
                    <p className="p-2 min-w-20 h-24 font-700 text-12 text-white rounded-2 chip-show text-actionPrimary border border-actionPrimary text-center">
                        {count}
                    </p>
                ) : null}
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                </svg>
            </div>
        </div>
    );
};

export default PastVisitsBt;
